module.exports = __webpack_public_path__ + "img/1fie-g-gu'unh (1).a2390675.jpg";